import React, { Component } from 'react';

class ReviewsSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row">
        {
          Array.from(Array(9).keys()).map((i) => {
            return (
              <div className="col-12 col-md-6 col-lg-4" key={i}>
                <div className="review-card bg-white skeleton">
                  <div className="inner-text">
                    <div className="author-name mb-4 skeleton-shine" />
                    <div className="date-created mb-4 skeleton-shine" />
                    <div className="title mb-3 skeleton-shine" />
                    <div className="text mb-2 skeleton-shine" />
                    <div className="text mb-2 skeleton-shine" />
                    <div className="text mb-2 skeleton-shine" />
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default ReviewsSkeleton;



// WEBPACK FOOTER //
// ./scripts/components/ReviewsSkeleton/ReviewsSkeleton.js